import React from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useNavigate } from '@tanstack/react-router';
import {
    filterVendor,
    filterBroker,
    selectVendors,
    selectBrokers,
    selectOrderOptions,
    selectVirtualBooths,
    selectShow
} from 'store/order';

import { isSevenEleven } from 'utility/utility';


import {
    Vendor,
    Broker,
    Show,
    OrderOption,
    VirtualBooth
} from 'model';
import { Button, Spin, Empty } from 'antd';

const BoothsPage: React.FC = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const vendors: Vendor[] = useAppSelector(selectVendors);

    const brokers: Broker[] = useAppSelector(selectBrokers);

    const virtualBooths: VirtualBooth[] = useAppSelector(selectVirtualBooths);

    const orderOptions: OrderOption = useAppSelector(selectOrderOptions);

    const show = useAppSelector(selectShow);

    React.useEffect(() => {
        document.title = `Booths | ${globalThis.showTitle}`;
    }, []);

    const boothOnClick = (booth: VirtualBooth) => {
        if (booth.vendorCount > 0) {
            console.log("Broker");
            const broker = brokers.find((broker: Broker) => {
                return broker.brokerId == booth.entityId;
            });
            dispatch(filterBroker(broker));
            navigate({ to: `/booth/${booth.entityId}` });
        } else {
            //console.log("Vendor");
            const vendor = vendors.find((vendor: Vendor) => {
                return vendor.vendorId == booth.entityId;
            });
            dispatch(filterVendor(vendor));
            navigate({ to: `/booth/${booth.entityId}` });
        }
    };

    const getVirtualBooths = () => {
        if (virtualBooths && virtualBooths.length > 0) {
            return virtualBooths.map((booth: VirtualBooth, index: number) => {
                if (booth.entityId == orderOptions.hostVendorId) {
                    return null;
                }
                return <div key={index} className="booth" onClick={() => boothOnClick(booth)}>
                    {(booth.logo && booth.logo.length > 0) &&
                        <img src={booth.logo} title={booth.name} />
                    }
                    <div className="title">
                        {booth.name}
                    </div>
                </div>
            });
        } else {
            return <div className="center-content"> <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /></div>;
        }
    }

    const getVirtualBooths7EE = () => {
        if (virtualBooths && virtualBooths.length > 0) {
            return virtualBooths.map((booth: VirtualBooth, index: number) => {
                if (booth.entityId == orderOptions.hostVendorId) {
                    return null;
                }
                return <div key={index} style={styles.booth} onClick={() => boothOnClick(booth)}>
                    {(booth.logo && booth.logo.length > 0) &&
                        <img src={booth.logo} title={booth.name} style={styles.boothImage} />
                    }
                </div>
            });
        } else {
            return <div className="center-content"> <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /></div>;
        }
    }

    if (isSevenEleven(show)) {
        return (
            <div className="page-content" style={styles.container}>
                <h1>
                    {orderOptions.virtualBoothTitle}
                </h1>
                <div className="content-html">
                    <div style={styles.booths}>
                        {getVirtualBooths7EE()}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="page-content" >
            <h1>
                {orderOptions.virtualBoothTitle}
            </h1>
            <div className="content-html">
                <div className="booths">
                    {getVirtualBooths()}
                </div>
            </div>
        </div>
    );
};

const styles: { [key: string]: React.CSSProperties } = {
    container: {
        backgroundColor: '#000000',
        backgroundImage: 'url("https://tradeshoweasy.s3.us-east-2.amazonaws.com/media/0/7EE-booths.png")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center top',
        backgroundSize: 'contain'
    },
    booths: {
        textAlign: 'center',
        margin: '0 auto',
        padding: '0',
        maxWidth: '600px',
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '20px',
        justifyContent: 'center'
    },
    booth: {
        padding: '20px',
        cursor: 'pointer',
        minHeight: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
        borderRadius: '8px',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease'
    },
    boothImage: {
        height: '120px',
        width: 'auto',
        maxWidth: '100%',
        objectFit: 'contain'
    }
};


export default BoothsPage;
